import { centsToDollars, parsePrice } from "helpers/price";
import { VerificationSteps } from "pages/VerificationPage/utils/constants";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { onVerificationStepChange } from "store/slices/verification";

import { StyledSuccessContainer } from "../styled";
import { BouncingCheck } from "./BouncingCheck";

export function PaymentSuccessFull({
  publicContact,
  orderExternalId,
  receiptAvailable = true,
  showPaymentPlanInfo,
  newDuration,
  newInstallmentAmount,
  orderUrl,
  showReceiptMessage = true,
}: {
  publicContact: any;
  orderExternalId: string;
  receiptAvailable?: boolean;
  showPaymentPlanInfo?: boolean;
  newDuration?: number;
  newInstallmentAmount?: number;
  orderUrl?: string;
  showReceiptMessage?: boolean;
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <StyledSuccessContainer className="w-full flex flex-column align-items-center pt-6 px-3">
      <div className="flex relative">
        <BouncingCheck />
        <p className="text-md gray line-height-3 message">Great Job!</p>
      </div>
      <p className="text-4xl font-semibold highlighted mt-1 text-center">
        Your Payment is Complete!
      </p>
      {!showPaymentPlanInfo && (
        <p className="text-center line-height-3 mt-4">
          Thank you for your payment—we&apos;ve got everything processed and
          ready for your next visit.
        </p>
      )}
      {showPaymentPlanInfo && (
        <p className="text-center line-height-3 mt-4">
          Your payment plan has been updated. You will be charged{" "}
          <span className="font-bold text-primary">
            {parsePrice(centsToDollars(newInstallmentAmount || 0))}
          </span>{" "}
          for <span className="font-bold text-primary">{newDuration}</span>{" "}
          installments.
        </p>
      )}
      {receiptAvailable && !showPaymentPlanInfo && (
        <p className="text-center line-height-3 mt-4">
          A copy of your receipt has been sent to your email.
        </p>
      )}
      <div
        className={`flex gap-3 align-items-center mt-5 ${
          receiptAvailable ? "flex-column md:flex-row" : "flex-column"
        }`}
      >
        {orderUrl && (
          <Button
            className="p-button-primary"
            onClick={() => navigate(orderUrl)}
          >
            <span className="text-white">View Estimate Details</span>
          </Button>
        )}

        {receiptAvailable && (
          <Button
            className="p-button p-button-outlined h-fit"
            onClick={() => {
              navigate(`/receipt/${orderExternalId}`);
              dispatch(
                onVerificationStepChange({ step: VerificationSteps.RECEIPT })
              );
            }}
          >
            View Receipt
          </Button>
        )}
        {!receiptAvailable && showReceiptMessage && (
          <p className="text-center line-height-3 mt-4 font-semibold">
            We&apos;re preparing your receipt and will email it to you shortly.
            Our team is working to ensure your records are complete.
          </p>
        )}
      </div>

      <Divider type="solid" className="mt-5" />
      <p className="highlighted font-medium text-xl line-height-3">
        Questions about your bill?
      </p>
      <p className="line-height-3 mt-1 text-center">
        Reach out to our support team anytime.
      </p>
      <div className="flex justify-content-center gap-4 mt-4">
        <div className="text-center gap-1 flex flex-column">
          <p className="text-sm line-height-3 font-semibold">Clear Health</p>
          <p className="text-sm line-height-3 font-normal">
            Estimate and Payment Support
          </p>
          <p className="text-sm line-height-3 font-normal">(888) 918-2522</p>
        </div>
        {publicContact().isVisible && (
          <div className="text-center flex flex-column">
            <p className="text-sm line-height-3 font-semibold">
              {publicContact().name}
            </p>
            <p className="text-sm line-height-3 gray">{publicContact().role}</p>
            <p className="text-sm line-height-3 gray">
              {publicContact().phone}
            </p>
          </div>
        )}
      </div>
    </StyledSuccessContainer>
  );
}
